// extracted by mini-css-extract-plugin
module.exports = {"BenefitsContainer":"NewPlan_BenefitsContainer__z3JQH","TrackableBenefitsEmpty":"NewPlan_TrackableBenefitsEmpty__22PWB"};